import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {BaseAnimationWrapper} from './BaseAnimationWrapper'

export class PositionAnimationWrapper extends BaseAnimationWrapper {
    private readonly object: PIXI.Container
    private readonly dimension: 'x' | 'y'

    constructor(object: PIXI.Container, dimension: 'x' | 'y', uiGameManager: UIGameManager, startValue: number, endValue: number, duration: number, startingDelay: number = 0) {
        super(uiGameManager, startValue, endValue, duration, startingDelay)
        this.object = object
        this.dimension = dimension
        this.setValue(startValue)
    }

    protected setValue(amount: number) {
        if(this.object.destroyed) return
        this.object.position[this.dimension] = amount
    }
}
